import { Component, OnInit, Output, EventEmitter, Inject, OnDestroy } from '@angular/core';
import { PaisosFilter } from '../../models/paisos-filter';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-paisos-filter',
  templateUrl: './paisos-filter.component.html',
  styleUrls: ['./paisos-filter.component.scss']
})
export class PaisosFilterComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  filter: PaisosFilter;

  @Output() notify: EventEmitter<PaisosFilter> = new EventEmitter<PaisosFilter>();

  constructor(
    public thisDialogRef: MatDialogRef<PaisosFilterComponent>,
    private i18n: I18n,
    @Inject(MAT_DIALOG_DATA) public data) {
    this.filter = data.filter;
  }

  ngOnInit() {
    this.subscription = Observable.fromEvent(document, 'keypress').subscribe((e: KeyboardEvent ) => {
      if (e.key === 'Enter') {
        this.apply();
      }
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  reset() {
    this.filter.clear();
    this.apply();
  }

  apply() {
    this.filter.updated();
    this.notify.emit(this.filter);
    this.thisDialogRef.close();
  }

  dismiss() {
    this.thisDialogRef.close();
  }

}
